export default __webpack_public_path__ + "static/media/table.7fa014d5.svg";